import React from "react"
import teamimage from "../../assets/images/team-image.png"

const teamMembers = [
  {
    name: "Onifade Dolapo",
    role: "Frontend Developer"
  },
  {
    name: "Emeka Pascal",
    role: "Mobile Developer"
  },
  {
    name: "Godspower Uche",
    role: "Backend Developer"
  },
  {
    name: "Olajide Joshua",
    role: "Frontend Developer/Product Designer"
  },
]

function AboutTeam() {
  return (
    <div className="team-row">
      <h1 className="team-row__title">Team </h1>
      <h1 className="team-row__subtitle">Management</h1>
      <div className="team-row__content">
        {teamMembers.map(teamMember => {
          return (
            <div>
              <img src={teamimage} className="team-row__image" alt="" />
              <h1 className="name">{teamMember.name} </h1>
              <p className="role">{teamMember.role}</p>
            </div>
          )
        })}
      </div>

    </div>
  )
}

export default AboutTeam